const CURRENCY_DEPENDENT_FILTERS = [
  "lowestPrice",
  "highestPrice",
  "hotelLowestPrice",
  "hotelHighestPrice",
];

export const getCurrencyChangedUrl = (
  url: string,
  currency: string,
  defaultCurrency: string | null
): string => {
  const parsedUrl = new URL(url);
  const currentCurrency =
    parsedUrl.searchParams.get("currency") || defaultCurrency || "";

  if (!currency || currency === currentCurrency) {
    return url;
  }

  if (currency === defaultCurrency) {
    parsedUrl.searchParams.delete("currency");
  } else {
    parsedUrl.searchParams.set("currency", currency);
  }

  CURRENCY_DEPENDENT_FILTERS.forEach((filterName) => {
    parsedUrl.searchParams.delete(filterName);
  });

  return parsedUrl.toString();
};
